import {createDomainEvent, DomainEvent} from './domain-event'

export const LayoutEventTypes = {
  UserNotHaveRequirementFields: 'layout.user_not_have_requirement_fields',
  StartRefreshPageData: 'layout.start_refresh_page_data',
  EndRefreshPageData: 'layout.end_refresh_page_data',
} as const

export type UserNotHaveRequirementsBasketEvent = DomainEvent
export type StartRefreshPageDataEvent = DomainEvent
export type EndRefreshPageDataEvent = DomainEvent

export const LayoutEvents = {
  userNotHaveRequirementFields(): UserNotHaveRequirementsBasketEvent {
    return createDomainEvent(LayoutEventTypes.UserNotHaveRequirementFields)
  },
  startRefreshPageData(): StartRefreshPageDataEvent {
    return createDomainEvent(LayoutEventTypes.StartRefreshPageData)
  },
  endRefreshPageData(): EndRefreshPageDataEvent {
    return createDomainEvent(LayoutEventTypes.EndRefreshPageData)
  },
}
